import React, { Component } from 'react'
import { connect } from 'react-redux';

class PreLoaderScreen extends Component {

    componentDidMount(){
        if(window.StatusBar) window.StatusBar.backgroundColorByHexString("#f5f5f5");
        if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(true);
    }

    componentWillUnmount() {
        if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(false);
        if(window.StatusBar && this.props.menuColor.backgroundColor) window.StatusBar.backgroundColorByHexString(this.props.menuColor.backgroundColor)
    }

    render() {
        
        return (
            <div class="overlay preloader">
                <div class="preload-header"></div>
                <div class="preload-body">
                    <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                   <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                   <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                   <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
    }
}

export default connect(mapStateToProps,{})(PreLoaderScreen);
